import { formatRFC3339 } from "date-fns";
import { v4 } from "uuid";
export class EventBase {
    #id;
    #context;
    #timestamp;
    #contentId;
    constructor({ context, contentId, }) {
        this.#id = v4();
        this.#timestamp = formatRFC3339(Date.now());
        this.#context = context;
        this.#contentId = contentId;
    }
    get id() {
        return this.#id;
    }
    get context() {
        return this.#context;
    }
    get timestamp() {
        return this.#timestamp;
    }
    get contentId() {
        return this.#contentId;
    }
    marshal() {
        return JSON.stringify({
            id: this.id,
            domain: this.domain,
            eventName: this.eventName,
            context: this.context,
            timestamp: this.timestamp,
            contentId: this.contentId,
        });
    }
    get eventNameSnakeCase() {
        return (this.eventName
            // Insert underscore before uppercase letters that follow lowercase letters
            .replace(/([a-z])([A-Z])/g, "$1_$2")
            // Insert underscore before uppercase letters that follow numbers
            .replace(/([0-9])([A-Z])/g, "$1_$2")
            // Replace spaces, hyphens, and other separators with underscores
            .replace(/[\s\-\.]+/g, "_")
            // Remove leading/trailing underscores
            .replace(/^_+|_+$/g, "")
            .toLowerCase());
    }
    get eventNameKababCase() {
        return this.eventName.replace(/ /g, "-").toLowerCase();
    }
}
//# sourceMappingURL=eventBase.js.map